import { prettyMatchType } from './prettyMatchType'

/**
 * Picks the match type text for a display, based on a theme's matchTypeFormat option.
 *
 * "short" -> sanitized key, suffixes like " - ABBA" / " - 3v3" dropped ("Bo5")
 * "long"  -> readable name from the match type store ("Best of 5")
 *
 * Both fall back to deriving from the match state, for saves written before the
 * match type store existed.
 */
export function matchTypeLabel(match, format = 'short') {
	if (!match) return ''

	const shortName = match.matchTypeDisplay ?? String(match.matchType ?? '').replace(/ - .*/, '')
	if (format !== 'long') return shortName

	return match.matchTypeLongName ?? prettyMatchType(shortName)
}

export default matchTypeLabel
